import { Option } from '../../Select/Select';
import { CarrierCompany } from '../../../../services/carrier';

export const mapCarriersToOptions = (carriers?: CarrierCompany[]): Option[] =>
  carriers?.map(c => ({
    label: c.name,
    value: c.id?.toString() ?? '',
  })) || [];

export const findCarrierOption = (options: Option[], carrierId?: number) =>
  options.find(opt => opt.value === carrierId?.toString());
